<template>
  <div>
    <ul class="tag-listing">
      <li v-for="chip in alwaysShownChips">
        <pill @onRemove="destroy(chip)" :value="chip[displayKey]" color="Orange"></pill>
      </li>
    </ul>
    <div class="cta-container" v-if="hasRevealableChips">
      <span class="hidden-counter" v-show="!isOpen" :class="{'sr-only': isOpen}">+ {{revealableCount}} more</span>
      <button
        type="button"
        @click="toggleOpen"
        :id="`moreChipsButton_${rootId}`"
        class="btn-icon light-grey show-tags collapsed"
        data-toggle="collapse"
        :data-target="`#moreChips_${rootId}`"
        aria-expanded="false">
        <icon class="arrow-chevron"></icon>
        <span class="sr-only">More Chips Dropdown</span>
      </button>
    </div>
    <div class="filter-expanded">
      <ul :id="`moreChips_${rootId}`" class="collapse tag-listing">
        <li v-for="chip in revealableChips">
          <pill @onRemove="destroy(chip)" :value="chip[displayKey]" :color="pillColor"></pill>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";

  export default Vue.extend({
    props: {
      chips: {
        type: Array as () => object[],
        default: [],
        required: true
      },
      displayKey: {
        type: String,
        default: 'name'
      },
      displayCount: {
        type: Number,
        default: null
      },
      rootId: {
        type: String,
        default: ''
      },
      pillColor: {
        type: String,
        default: 'Orange'
      }
    },
    data: function () {
      return {
        isOpen: false
      };
    },
    computed: {
      alwaysShownChips(): string[] {
        return this.chips.slice(0, this.displayCountComputed);
      },
      revealableChips(): string[] {
        return this.chips.slice(this.displayCountComputed);
      },
      hasRevealableChips(): boolean {
        return this.revealableChips.length > 0;
      },
      defaultDisplayCount(): number {
       return this.chips.length;
      },
      displayCountComputed(): number {
        return this.displayCount === null ? this.defaultDisplayCount : this.displayCount;
      },
      revealableCount(): number {
        return this.chips.length - this.alwaysShownChips.length;
      }
    },
    methods: {
      destroy(chip) {
        this.$emit('destroy', chip);
      },
      toggleOpen(): void {
        this.isOpen = !this.isOpen;
      }
    }
  });
</script>